import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { AI_RECOMMENDATION_CHOICE } = STEP_IDENTIFIER_NAME;

export const aiRecommendationChoice: StepConfig = {
	name: AI_RECOMMENDATION_CHOICE,
	isAuthenticationRequired: false,
	isEnabled: () => true,
};
